import type {
  ComponentSettings,
  ComponentSettingsProps,
} from "@repo/editor/externalComponents";
import * as t from "@rekajs/types";
import type { ComponentType } from "@repo/editor/types";
import { forwardRef } from "react";

const ContactDetailDefinition: ComponentSettingsProps = {
  title: {
    type: "string",
    label: "عنوان",
    default: "عنوان",
  },
  description: {
    type: "html",
    label: "توضیحات",
    default: "توضیحات",
  },
};
export interface ContactDetailProps {
  title: string;
  description: string;
  children: React.ReactNode;
}

export const ContactDetail = forwardRef(
  (props: ContactDetailProps, ref: React.Ref<HTMLDivElement>) => {
    return (
      <div
        className="w-full h-full flex flex-col lg:gap-6 md:gap-4 gap-3 relative"
        ref={ref}
      >
        <img
          alt="map"
          className="absolute top-0 right-0 lg:w-2/3 w-full h-full object-contain"
          src="/images/map2.png"
        />
        <h1 className="font-helvetica rtl:font-doran rtl:font-medium text-[25px] md:text-[50px] lg:text-[83.9px] font-[100] text-[#131d29]">
          {props.title}
        </h1>
        <div
          className="text-[12.8px] md:text-[20px] lg:text-[37px] font-helvetica rtl:font-doran rtl:font-light font-[100] ql-editor text-[#131d29]"
          dangerouslySetInnerHTML={{ __html: props.description }}
        />
        <div className="grid grid-cols-2 lg:grid-cols-3 pt-6 gap-4 relative">
          {/* TODO: dynamic this component with children */}
          {props.children}
        </div>
      </div>
    );
  }
) as ComponentType<ContactDetailProps>;

ContactDetail.displayName = "EContactDetail";

export const contactDetailSettings: ComponentSettings = {
  name: "EContactDetail",
  props: ContactDetailDefinition,
  label: "جزئیات تماس با ما",
  childrenAllowed: ["EContactDetailItem"],
  widgets: {
    label: "جزئیات تماس با ما",
    template: () =>
      t.componentTemplate({
        component: t.identifier({ name: "EContactDetail", external: true }),
        children: [
          t.componentTemplate({
            component: t.identifier({
              name: "EContactDetailItem",
              external: true,
            }),
          }),
        ],
      }),
  },
};

ContactDetail.componentSettings = contactDetailSettings;
